/*
 * Load the images we want to use for each question and store them in a
 * dictionary where the question ID is the key.
 */

import napImage from "../../images/morning-sleep.svg";
import swimmingImage from "../../images/swimming.svg";
import coffeeImage from "../../images/coffee-break.svg";
import coffeeWorkImage from "../../images/coffee-work.svg";
import commuteImage from "../../images/commute.svg";
import eatingLunchImage from "../../images/eating-lunch.svg";
import eatingOutImage from "../../images/eating-lunch-out.svg";
import eatingLunchOffice from "../../images/eating-lunch-office.svg";
import luxuryImage from "../../images/luxury.svg";
import shoppingImage from "../../images/market.svg";
import hamburgerImage from "../../images/hamburger.svg";
import bombImage from "../../images/bomb.svg";
import petImage from "../../images/pet.svg";
import recycleImage from "../../images/recycle.svg";
import rocketImage from "../../images/goal.svg";
import foodPlateImage from "../../images/vegetarian.svg";

// Map an ID to an Image to show when asking the question
const quizImages = {
  wash: napImage,
  commute: commuteImage,
  "wash-followup": swimmingImage,
  "coffee-catchup": coffeeImage,
  "followup-coffee-work": coffeeWorkImage,
  "followup-coffee-cafe": coffeeImage,
  lunch: eatingLunchOffice,
  "lunch-followup-home": eatingLunchImage,
  "lunch-followup-office": eatingLunchOffice,
  "lunch-followup-out": eatingOutImage,
  "grocery-shopping": hamburgerImage,
  "grocery-shopping-bags": shoppingImage,
  clothes: luxuryImage,
  cleaning: bombImage,
  chores: petImage,
  "followup-chores-recycling": recycleImage,
  recreation: rocketImage,
  compost: foodPlateImage
};

export default quizImages;
